<!-- 关于我们 -->
<template>
  <div>
    <el-container>
      <el-header class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
        </div>
        <p>关于我们</p>
      </el-header>
      <el-main class="mainContent">
        <div style="margin:0 auto;text-align:center;margin-top:-100px">
          <img src="@/assets/images/mobile/codeimg.png" alt="" style="width:200px;margin-bottom:20px"/>
          <p style="margin-bottom:20px">主办单位：信阳市人民政府</p>
          <p >版权所有：信阳市人民政府</p>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  created() {},

  mounted() {},

  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  z-index: 100;
  width: 100%;
  height: 5.25rem!important;
  background-color: #36aa60;
  position: relative;
  .header-wrap {
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
    .header-img {
      width: 30px;
      height: 30px;
      margin-top: 1rem;
    }
  }
  p {
    height: 20px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    line-height: 4;
    letter-spacing: 0.5rem;
  }
}
.mainContent {
  padding-top: 0;
  height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: #000;
    font-size: 20px;
    letter-spacing: 2px;
  }
}
</style>
